module.exports = __webpack_public_path__ + "static/media/teacher.4788048f.png";